import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLanguage, faArrowLeft, faUserCircle, faBell, faEnvelope, faDesktop } from '@fortawesome/free-solid-svg-icons';
import TranslationTool from './Tools/TranslationTool/TranslationTool';
import AccountSettings from './Tools/AccountSettings/AccountSettings';
import './Settings.css';

function Settings({ user }) {
    const [selectedTool, setSelectedTool] = useState(null);

    const tools = [
        {
            id: 'translation',
            name: 'Translation Tool',
            icon: faLanguage,
            description: 'Manage and edit translations for the platform',
            component: TranslationTool
        },
        {
            id: 'account',
            name: 'Account Settings',
            icon: faUserCircle,
            description: 'View and edit your account details',
            component: AccountSettings
        },
        // More tools can be added here as needed
    ];

    const renderToolContent = () => {
        const tool = tools.find(t => t.id === selectedTool);
        if (!tool) return null;
        
        const ToolComponent = tool.component;
        return <ToolComponent user={user} />;
    };

    const renderContent = () => {
        if (selectedTool) {
            return renderToolContent();
        }

        return (
            <div className="settings-grid">
                {tools.map((tool) => (
                    <div 
                        key={tool.id} 
                        className="settings-card"
                        onClick={() => setSelectedTool(tool.id)}
                    >
                                    <div className="settings-icon">

                        <FontAwesomeIcon icon={tool.icon} />
                        </div>

                        <div className="settings-text">
                            {tool.name}


                        <div className="settings-description">{tool.description}</div>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    return (
        <div className="settings-container">
            <div className="settings-header">
                {selectedTool && (
                    <div className="settings-nav" onClick={() => setSelectedTool(null)}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </div>
                )}
            </div>
            <div className="settings-content">
                {renderContent()}
            </div>
        </div>
    );
}

export default Settings;
